import { Record, type RecordOf } from 'immutable';

import type { Dataset } from '../datasets/datasetsTypes';

export const AUTH_REDUCER_KEY = 'authStore';
export type AUTH_REDUCER_KEY = typeof AUTH_REDUCER_KEY;

export interface AuthTokenDataProps {
  accessToken?: string;
  accessTokenExpired?: string;
  refreshToken?: string;
  refreshTokenExpired?: string;
  scope?: string;
  surveyRequested?: boolean;
}
export const AuthTokenData = Record<AuthTokenDataProps>({
  accessToken: undefined,
  accessTokenExpired: undefined,
  refreshToken: undefined,
  refreshTokenExpired: undefined,
  scope: undefined,

  surveyRequested: undefined,
});

export interface ExchangeRefreshToken {
  grantType: string;
  responseType: string;
  redirectUri: string;
  clientId: string;
  clientSecret: string;
  refreshToken: string;
}

export const AuthSessionSources = Object.freeze({
  SESSION_STORAGE: 'SESSION_STORAGE',
  REDUX_PERSIST: 'REDUX_PERSIST',
  MASTER: 'MASTER',
});
export type AuthSessionSource = `${(typeof AuthSessionSources)[keyof typeof AuthSessionSources]}`;

export interface AuthStoreProps {
  source?: AuthSessionSource | null;
  qcsId?: string | null;
  datasetId?: string | null;
  datasetPlatform?: string | null;
  datasetSubscriptionTier?: string | null;
  datasetCreatedByClientId?: string | null;
  datasetCreatedAt?: string | null;

  accessToken?: string | null;
  accessTokenExpired?: string | null;
  refreshToken?: string | null;
  refreshTokenExpired?: string | null;
  scope?: string | null;

  groups?: string | null;

  surveyRequested?: boolean | null;

  isLoading?: boolean | null;
  error?: any;
  isSanitized?: boolean | null;
}
export type AuthStore = RecordOf<AuthStoreProps>;

export const mkAuthStore = Record<AuthStoreProps>({
  source: undefined, // AuthSessionSources
  qcsId: undefined,
  datasetId: undefined,
  datasetPlatform: undefined,
  datasetSubscriptionTier: undefined,
  datasetCreatedByClientId: undefined,
  datasetCreatedAt: undefined,

  accessToken: undefined,
  accessTokenExpired: undefined,
  refreshToken: undefined,
  refreshTokenExpired: undefined,
  scope: undefined,

  groups: undefined,

  surveyRequested: undefined,

  isLoading: undefined,
  error: undefined,
  isSanitized: undefined,
});

export interface AuthSelectDatasetPayloadProps {
  dataset?: Dataset | null;
  userChoice?: boolean;
  reload: boolean;
  location: string;
}

export const AuthSelectDatasetPayload = Record<AuthSelectDatasetPayloadProps>({
  dataset: undefined,

  userChoice: undefined,
  reload: true,
  location: '/',
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [AUTH_REDUCER_KEY]: RecordOf<AuthStoreProps>;
  }
}
